module.exports = new __parcel__URL__("halo-combat-evolved.e4ad87c1.jpg").toString();